import { ref, firebaseAuth } from '../config/constants';

export function auth(email, pw) {
  return firebaseAuth()
    .createUserWithEmailAndPassword(email, pw)
    .then(saveUser);
}

export function signout() {
  return firebaseAuth().signOut();
}

export function login(email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw);
}

export function resetPassword(email) {
  return firebaseAuth().sendPasswordResetEmail(email);
}

export function currentUser() {
  return firebaseAuth().currentUser;
}

// TODO: Save stripe plan seperately
export function saveUser(user) {
  return ref
    .child(`users/${user.uid}/info`)
    .set({
      email: user.email,
      uid: user.uid
    })
    .then(() => {
      // Get user info
      let info = ref.child(`/users/${user.uid}/info`).once('value');
      return info;
    })
    .then((snapshot) => {
      // Return info snapshot
      return snapshot.val();
    });
}

export function getUserInfo(uid) {
  return ref
    .child(`/users/${uid}`)
    .once('value')
    .then((snapshot) => snapshot.val());
}

export function saveStripeInfo(stripeInfo) {
  const user = currentUser();
  return ref
    .child(`users/${user.uid}/plan`)
    .set(stripeInfo)
    .then(() => {
      // Get user info
      let plan = ref.child(`/users/${user.uid}`).once('value');
      console.log(plan);

      return plan;
    })
    .then((snapshot) => {
      // Return info snapshot
      return snapshot.val();
    });
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js